import { Link, matchPath, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import { useEffect, useState } from "react";

const Sidebar = () => {
    const closeDrawer = () => {
        let html = document.querySelector("html");
        html.classList.remove("layout-menu-expanded");
    };

    const auth_user = JSON.parse(localStorage.getItem("user"));
    const isSuperAdmin = auth_user?.user_type === 1 ? 1 : 0;
    const isRegionAdmin = auth_user?.user_type === 2 ? 1 : 0;
    const isChapterAdmin = auth_user?.user_type === 3 ? 1 : 0;


    const isParentPath = (url) =>
        matchPath(url, window.location.pathname) != null;
    const location = useLocation();

    const dashboardRoute = () =>
        isParentPath("/") ||
        isParentPath("/home") ||
        isParentPath("/dashboard");

    const userRoutes = () =>
        isParentPath("/users") ||
        isParentPath("/user/create") ||
        isParentPath("/user/:id/edit");

    const regionAdminRoutes = () =>
        isParentPath("/region-admin-users") ||
        isParentPath("/region-admin-user/create") ||
        isParentPath("/region-admin-user/:id/edit");

    const chapterAdminRoutes = () =>
        isParentPath("/chapter-admin-users") ||
        isParentPath("/chapter-admin-user/create") ||
        isParentPath("/chapter-admin-user/:id/edit");

    const chapterRoutes = () =>
        isParentPath("/chapters") ||
        isParentPath("/create/chapter") ||
        isParentPath("/chapter/:id/edit");

    const userRoleRoutes = () =>
        isParentPath("/user-roles") ||
        isParentPath("/create/user-role") ||
        isParentPath("/user-role/:id/edit");

    const categoryRoutes = () =>
        isParentPath("/category") ||
        isParentPath("/create/category") ||
        isParentPath("/category/:id/edit");

    const regionRoutes = () =>
        isParentPath("/regions") ||
        isParentPath("/create/region") ||
        isParentPath("/region/:id/edit");

    const tyfcbRoutes = () =>
        isParentPath("/tyfcbs");

    const onetooneRoutes = () =>
        isParentPath("/one-to-one");

    const referralRoutes = () =>
        isParentPath("/referrals");

    const visitorRoutes = () =>
        isParentPath("/visitors");

    const weeklyMeetingFeesRoutes = () =>
        isParentPath("/weekly-meeting-fees");

    const eventRoutes = () =>
        isParentPath("/events") ||
        isParentPath("/create/event") ||
        isParentPath("/event/:id/edit");

    const pointsRoutes = () =>
        isParentPath("/points");

    useEffect(() => { }, [location]);

    const [showSubMenu, setShowSubMenu] = useState(false);

    const toggleSubMenu = () => {
        setShowSubMenu(!showSubMenu);
    };
    // New
    // const [activeMenu, setActiveMenu] = useState('');

    // const handleMenuClick = (menu) => {
    //     setActiveMenu(activeMenu === menu ? '' : menu);
    // };

    // function MenuItem({ title, iconClass, children, activeMenu, setActiveMenu }) {
    //     const isOpen = activeMenu === title;

    //     return (
    //         <li className={`menu-child ${isOpen ? 'active' : ''}`}>
    //             <Link onClick={() => handleMenuClick(title)}>
    //                 <i className={iconClass}></i> {title}
    //             </Link>
    //             <ul style={{ display: isOpen ? 'block' : 'none' }}>
    //                 {children}
    //             </ul>
    //         </li>
    //     );
    // }
    const [activeMenu, setActiveMenu] = useState('');

    const handleMenuClick = (menu) => {
        setActiveMenu((prevActiveMenu) => (prevActiveMenu === menu ? '' : menu));
    };

    function MenuItem({ title, iconClass, children }) {
        const isOpen = activeMenu === title;

        return (
            <li className={`menu-child ${isOpen ? 'active' : ''}`}>
                <Link to="#" onClick={() => handleMenuClick(title)}> {/* Replace <a> with <Link> */}
                    <i className={iconClass}></i> {title}
                </Link>
                <ul style={{ display: isOpen ? 'block' : 'none' }}>
                    {children}
                </ul>
            </li>
        );
    }
    // New

    return (
        <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme darkbg">
            <div className="app-brand demo text-center">
                <a href="/" className="app-brand-link d-block">
                    <span className="app-brand-text demo menu-text fw-bolder ms-2">
                        <img src={logo} alt="Logo" />
                    </span>
                </a>
                <div className="layout-menu-toggle menu-link text-large ms-auto"
                    onClick={closeDrawer}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </div>
            </div>

            <div className="menu-inner-shadow"></div>

            <ul className="menu-inner dark-bg-inner py-3">
                <li className={dashboardRoute() ? "menu-item active" : "menu-item"}>
                    <Link className="menu-link" to="/dashboard">
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.32" d="M21.1808 16.9703C20.8971 17.6255 20.2225 18 19.5086 18H14.8154C14.8462 17.9145 14.8735 17.8269 14.8971 17.7373C15.1709 16.6974 14.8825 15.639 14.2214 14.8963C14.4654 12.9091 14.6177 10.8733 14.7108 9.26516C14.7569 8.46731 13.7795 8.20081 13.4274 8.91526C12.7178 10.3553 11.8493 12.1958 11.0842 14.041C10.1467 14.3479 9.3768 15.1177 9.10295 16.1576C8.93642 16.7899 8.97782 17.4291 9.18451 18H4.49141C3.77747 18 3.10288 17.6255 2.81918 16.9703C2.29212 15.7533 2 14.4108 2 13C2 7.47715 6.47715 3 12 3C17.5229 3 22 7.47715 22 13C22 14.4108 21.7079 15.7533 21.1808 16.9703Z" />
                                <path d="M14.7108 9.26516C14.7569 8.46731 13.7795 8.20081 13.4274 8.91526C12.7178 10.3553 11.8493 12.1958 11.0842 14.041C10.1467 14.3479 9.3768 15.1177 9.10295 16.1576C8.6742 17.7856 9.62375 19.459 11.2238 19.8953C12.8238 20.3315 14.4684 19.3654 14.8971 17.7373C15.1709 16.6974 14.8825 15.639 14.2214 14.8963C14.4654 12.9091 14.6177 10.8733 14.7108 9.26516Z" />
                            </svg>
                        </div>
                        <div data-i18n="Analytics">Dashboard</div>
                    </Link>
                </li>

                <li className={userRoutes() ? "menu-item active" : "menu-item"}>
                    <Link className="menu-link" to="users">
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.32" d="M2.28099 19.6575C2.36966 20.5161 2.93261 21.1957 3.77688 21.3755C5.1095 21.6592 7.6216 22 12 22C16.3784 22 18.8905 21.6592 20.2232 21.3755C21.0674 21.1957 21.6303 20.5161 21.719 19.6575C21.8505 18.3844 22 16.0469 22 12C22 7.95305 21.8505 5.6156 21.719 4.34251C21.6303 3.48389 21.0674 2.80424 20.2231 2.62451C18.8905 2.34081 16.3784 2 12 2C7.6216 2 5.1095 2.34081 3.77688 2.62451C2.93261 2.80424 2.36966 3.48389 2.28099 4.34251C2.14952 5.6156 2 7.95305 2 12C2 16.0469 2.14952 18.3844 2.28099 19.6575Z" />
                                <path d="M13.9382 13.8559C15.263 13.1583 16.1663 11.7679 16.1663 10.1666C16.1663 7.8655 14.3008 6 11.9996 6C9.69841 6 7.83291 7.8655 7.83291 10.1666C7.83291 11.768 8.73626 13.1584 10.0612 13.856C8.28691 14.532 6.93216 16.1092 6.51251 18.0529C6.45446 18.3219 6.60246 18.5981 6.87341 18.6471C7.84581 18.8231 9.45616 19 12.0006 19C14.545 19 16.1554 18.8231 17.1278 18.6471C17.3977 18.5983 17.5454 18.3231 17.4876 18.0551C17.0685 16.1103 15.7133 14.5321 13.9382 13.8559Z" />
                            </svg>
                        </div>
                        <div data-i18n="Analytics">Members</div>
                    </Link>
                </li>

                <li className={tyfcbRoutes() ? "menu-item active" : "menu-item"}>
                    <Link className="menu-link" to={"tyfcbs"}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-emoji-smile-fill" viewBox="0 0 16 16"> <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zM4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z" /> </svg>
                        <div data-i18n="Analytics">TYNs</div>
                    </Link>
                </li>
                <li className={onetooneRoutes() ? "menu-item active" : "menu-item"}>
                    <Link className="menu-link" to={"one-to-one"}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.32" d="M2.28099 19.6575C2.36966 20.5161 2.93261 21.1957 3.77688 21.3755C5.1095 21.6592 7.6216 22 12 22C16.3784 22 18.8905 21.6592 20.2232 21.3755C21.0674 21.1957 21.6303 20.5161 21.719 19.6575C21.8505 18.3844 22 16.0469 22 12C22 7.95305 21.8505 5.6156 21.719 4.34251C21.6303 3.48389 21.0674 2.80424 20.2231 2.62451C18.8905 2.34081 16.3784 2 12 2C7.6216 2 5.1095 2.34081 3.77688 2.62451C2.93261 2.80424 2.36966 3.48389 2.28099 4.34251C2.14952 5.6156 2 7.95305 2 12C2 16.0469 2.14952 18.3844 2.28099 19.6575Z" />
                            <path d="M13.9382 13.8559C15.263 13.1583 16.1663 11.7679 16.1663 10.1666C16.1663 7.8655 14.3008 6 11.9996 6C9.69841 6 7.83291 7.8655 7.83291 10.1666C7.83291 11.768 8.73626 13.1584 10.0612 13.856C8.28691 14.532 6.93216 16.1092 6.51251 18.0529C6.45446 18.3219 6.60246 18.5981 6.87341 18.6471C7.84581 18.8231 9.45616 19 12.0006 19C14.545 19 16.1554 18.8231 17.1278 18.6471C17.3977 18.5983 17.5454 18.3231 17.4876 18.0551C17.0685 16.1103 15.7133 14.5321 13.9382 13.8559Z" />
                        </svg>
                        <div data-i18n="Analytics">121s</div>
                    </Link>
                </li>
                <li className={referralRoutes() ? "menu-item active" : "menu-item"}>
                    <Link className="menu-link" to={"referrals"}>
                        <div>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.32" d="M2.28099 19.6575C2.36966 20.5161 2.93261 21.1957 3.77688 21.3755C5.1095 21.6592 7.6216 22 12 22C16.3784 22 18.8905 21.6592 20.2232 21.3755C21.0674 21.1957 21.6303 20.5161 21.719 19.6575C21.8505 18.3844 22 16.0469 22 12C22 7.95305 21.8505 5.6156 21.719 4.34251C21.6303 3.48389 21.0674 2.80424 20.2231 2.62451C18.8905 2.34081 16.3784 2 12 2C7.6216 2 5.1095 2.34081 3.77688 2.62451C2.93261 2.80424 2.36966 3.48389 2.28099 4.34251C2.14952 5.6156 2 7.95305 2 12C2 16.0469 2.14952 18.3844 2.28099 19.6575Z" />
                                <path d="M13.9382 13.8559C15.263 13.1583 16.1663 11.7679 16.1663 10.1666C16.1663 7.8655 14.3008 6 11.9996 6C9.69841 6 7.83291 7.8655 7.83291 10.1666C7.83291 11.768 8.73626 13.1584 10.0612 13.856C8.28691 14.532 6.93216 16.1092 6.51251 18.0529C6.45446 18.3219 6.60246 18.5981 6.87341 18.6471C7.84581 18.8231 9.45616 19 12.0006 19C14.545 19 16.1554 18.8231 17.1278 18.6471C17.3977 18.5983 17.5454 18.3231 17.4876 18.0551C17.0685 16.1103 15.7133 14.5321 13.9382 13.8559Z" />
                            </svg>

                        </div>
                        <div data-i18n="Analytics">RFLs</div>
                    </Link>
                </li>
                <li className={visitorRoutes() ? "menu-item active" : "menu-item"}>
                    <Link className="menu-link" to={"visitors"}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.32" d="M2.28099 19.6575C2.36966 20.5161 2.93261 21.1957 3.77688 21.3755C5.1095 21.6592 7.6216 22 12 22C16.3784 22 18.8905 21.6592 20.2232 21.3755C21.0674 21.1957 21.6303 20.5161 21.719 19.6575C21.8505 18.3844 22 16.0469 22 12C22 7.95305 21.8505 5.6156 21.719 4.34251C21.6303 3.48389 21.0674 2.80424 20.2231 2.62451C18.8905 2.34081 16.3784 2 12 2C7.6216 2 5.1095 2.34081 3.77688 2.62451C2.93261 2.80424 2.36966 3.48389 2.28099 4.34251C2.14952 5.6156 2 7.95305 2 12C2 16.0469 2.14952 18.3844 2.28099 19.6575Z" />
                            <path d="M13.9382 13.8559C15.263 13.1583 16.1663 11.7679 16.1663 10.1666C16.1663 7.8655 14.3008 6 11.9996 6C9.69841 6 7.83291 7.8655 7.83291 10.1666C7.83291 11.768 8.73626 13.1584 10.0612 13.856C8.28691 14.532 6.93216 16.1092 6.51251 18.0529C6.45446 18.3219 6.60246 18.5981 6.87341 18.6471C7.84581 18.8231 9.45616 19 12.0006 19C14.545 19 16.1554 18.8231 17.1278 18.6471C17.3977 18.5983 17.5454 18.3231 17.4876 18.0551C17.0685 16.1103 15.7133 14.5321 13.9382 13.8559Z" />
                        </svg>
                        <div data-i18n="Analytics">Visitors</div>
                    </Link>
                </li>

                <li className={weeklyMeetingFeesRoutes() ? "menu-item active" : "menu-item"}>
                    <Link className="menu-link" to={"weekly-meeting-fees"}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.32">
                                <path d="M12 10.75C16.7038 10.75 19.4773 10.6481 20.868 10.5745C21.5117 10.5404 22 10.0077 22 9.36312V8.19432C22 7.74462 21.8551 7.30342 21.5366 6.98592C19.6683 5.12352 15.3747 2.72326 12.465 2.08812C12.1576 2.021 11.8424 2.021 11.535 2.08812C8.62535 2.72326 4.33171 5.12352 2.4634 6.98592C2.1449 7.30342 2 7.74462 2 8.19432V9.36312C2 10.0077 2.48829 10.5404 3.13195 10.5745C4.52271 10.6481 7.29615 10.75 12 10.75Z" />
                                <path d="M2.1787 18.7287C2.30863 18.3515 2.68627 18.1799 3.0846 18.1573C4.11911 18.0986 6.6517 18 12 18C17.3483 18 19.8809 18.0986 20.9154 18.1573C21.3137 18.1799 21.6914 18.3515 21.8213 18.7287C21.9176 19.0082 22 19.4175 22 20C22 20.5825 21.9176 20.9919 21.8213 21.2714C21.6914 21.6486 21.3137 21.8201 20.9154 21.8427C19.8809 21.9015 17.3483 22 12 22C6.6517 22 4.11911 21.9015 3.0846 21.8427C2.68627 21.8201 2.30863 21.6486 2.1787 21.2714C2.08243 20.9919 2 20.5825 2 20C2 19.4175 2.08243 19.0082 2.1787 18.7287Z" />
                            </g>
                            <path d="M12 9C13.1046 9 14 8.10457 14 7C14 5.89543 13.1046 5 12 5C10.8954 5 10 5.89543 10 7C10 8.10457 10.8954 9 12 9Z" />
                            <path d="M13.9467 10.7438C13.3382 10.7478 12.6899 10.75 12 10.75C11.3101 10.75 10.6618 10.7478 10.0533 10.7438C10.0277 11.3951 10 12.5511 10 14.5C10 16.2195 10.0216 17.3217 10.0442 18.0047C10.65 18.0017 11.3009 18 12 18C12.6991 18 13.35 18.0017 13.9558 18.0047C13.9784 17.3217 14 16.2195 14 14.5C14 12.5511 13.9723 11.3951 13.9467 10.7438Z" />
                            <path d="M16.0542 10.7212C16.0284 11.3682 16 12.5284 16 14.5C16 16.2343 16.022 17.3407 16.0448 18.0223C17.8468 18.0443 19.1022 18.0792 19.9521 18.1123C19.976 17.4396 20 16.3128 20 14.5C20 12.4185 19.9684 11.2414 19.9415 10.6177C19.0121 10.6562 17.7369 10.6956 16.0542 10.7212Z" />
                            <path d="M4.05845 10.6177C4.98788 10.6562 6.26314 10.6956 7.94583 10.7212C7.97163 11.3682 8 12.5284 8 14.5C8 16.2343 7.97805 17.3407 7.9552 18.0223C6.15324 18.0443 4.89779 18.0792 4.04791 18.1123C4.024 17.4396 4 16.3128 4 14.5C4 12.4185 4.03165 11.2414 4.05845 10.6177Z" />
                        </svg>

                        <div data-i18n="Analytics">Weekly Meeting Fees</div>
                    </Link>
                </li>

                <li className={eventRoutes() ? "menu-item active" : "menu-item"}>
                    <Link className="menu-link" to={"events"}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.32" fillRule="evenodd" clipRule="evenodd" d="M2.12411 8H21.8758C21.9467 9.20109 22 10.8266 22 13C22 16.4843 21.8631 18.5605 21.7362 19.7371C21.6422 20.6088 21.0518 21.281 20.1903 21.4442C18.8494 21.6983 16.3428 22 12 22C7.65725 22 5.15055 21.6983 3.80967 21.4442C2.94826 21.281 2.35785 20.6088 2.26379 19.7371C2.13682 18.5605 2 16.4843 2 13C2 10.8266 2.05324 9.20109 2.12411 8ZM6.5 12.6815C6.5 12.0806 6.93315 11.6082 7.5337 11.5868C8.3136 11.559 9.6669 11.5275 12 11.5069C14.5069 11.4848 15.8826 11.5197 16.6312 11.5599C17.1554 11.5881 17.5 11.9946 17.5 12.5196V12.9107C17.5 13.4726 17.1157 13.9093 16.5543 13.934C15.7898 13.9675 14.4235 14 12 14C9.5765 14 8.21025 13.9675 7.44565 13.934C6.88435 13.9093 6.5 13.4726 6.5 12.9107V12.6815ZM6.5 17.0891C6.5 16.5276 6.8844 16.0793 7.44515 16.0503C7.97275 16.0231 8.7795 16.0001 10 16.0001C11.2205 16.0001 12.0272 16.0231 12.5548 16.0503C13.1156 16.0793 13.5 16.5276 13.5 17.0891V17.4111C13.5 17.9726 13.1156 18.4208 12.5548 18.4498C12.0272 18.4771 11.2205 18.5001 10 18.5001C8.7795 18.5001 7.97275 18.4771 7.44515 18.4498C6.8844 18.4208 6.5 17.9726 6.5 17.4111V17.0891Z" />
                            <path d="M17.915 2.03126C18.2276 2.05703 18.4424 2.28598 18.4636 2.59889C18.4831 2.88636 18.5 3.32917 18.5 4C18.5 4.10776 18.4995 4.20964 18.4987 4.30593C19.1999 4.38632 19.7561 4.47356 20.1902 4.55581C21.0516 4.71901 21.642 5.39115 21.7361 6.26285C21.7839 6.7055 21.833 7.27555 21.8758 8H2.12402C2.16677 7.27555 2.21593 6.7055 2.2637 6.26285C2.35776 5.39115 2.94817 4.71902 3.80958 4.55581C4.24369 4.47355 4.8 4.3863 5.50125 4.30591C5.50045 4.20962 5.5 4.10775 5.5 4C5.5 3.32917 5.5169 2.88636 5.5364 2.59889C5.5576 2.28598 5.7724 2.05703 6.08495 2.03126C6.29765 2.01372 6.5938 2 7 2C7.4062 2 7.70235 2.01372 7.91505 2.03126C8.2276 2.05703 8.4424 2.28598 8.4636 2.59889C8.4831 2.88636 8.5 3.32917 8.5 4C8.5 4.0254 8.5 4.05047 8.49995 4.07521C9.50645 4.02844 10.6666 4 11.9999 4C13.3332 4 14.4935 4.02845 15.5 4.07522L15.5 4C15.5 3.32917 15.5169 2.88636 15.5364 2.59889C15.5576 2.28598 15.7724 2.05703 16.0849 2.03126C16.2976 2.01372 16.5938 2 17 2C17.4062 2 17.7023 2.01372 17.915 2.03126Z" />
                            <path fillRule="evenodd" clipRule="evenodd" d="M7.5337 11.5868C6.93315 11.6081 6.5 12.0805 6.5 12.6815V12.9107C6.5 13.4725 6.88435 13.9093 7.44565 13.9339C8.21025 13.9674 9.5765 14 12 14C14.4235 14 15.7897 13.9674 16.5543 13.9339C17.1156 13.9093 17.5 13.4725 17.5 12.9107V12.5196C17.5 11.9946 17.1554 11.5881 16.6312 11.5599C15.8825 11.5196 14.5069 11.4847 12 11.5069C9.6669 11.5274 8.3136 11.559 7.5337 11.5868ZM7.44515 16.0503C6.8844 16.0793 6.5 16.5275 6.5 17.089V17.411C6.5 17.9725 6.8844 18.4208 7.44515 18.4498C7.97275 18.477 8.7795 18.5 10 18.5C11.2205 18.5 12.0272 18.477 12.5548 18.4498C13.1156 18.4208 13.5 17.9725 13.5 17.411V17.089C13.5 16.5275 13.1156 16.0793 12.5548 16.0503C12.0272 16.023 11.2205 16 10 16C8.7795 16 7.97275 16.023 7.44515 16.0503Z" />
                        </svg>
                        <div data-i18n="Analytics">Events</div>
                    </Link>
                </li>

                <li className={pointsRoutes() ? "menu-item active" : "menu-item"}>
                    <Link className="menu-link" to={"points"}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path opacity="0.32" fillRule="evenodd" clipRule="evenodd" d="M1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12ZM12.9491 5.80725C12.5501 5.06425 11.4499 5.06425 11.051 5.80725L9.54862 8.60535L6.36352 9.2112C5.54932 9.36605 5.22022 10.319 5.77507 10.9151L8.03362 13.3415L7.61877 16.5888C7.51432 17.4065 8.39427 18.0073 9.15727 17.6394L12 16.2687L14.8428 17.6394C15.6058 18.0073 16.4857 17.4065 16.3813 16.5888L15.9664 13.3415L18.225 10.9151C18.7798 10.319 18.4507 9.36605 17.6365 9.2112L14.4514 8.60535L12.9491 5.80725Z" />
                            <path d="M11.0509 5.80725C11.4499 5.06425 12.5501 5.06425 12.949 5.80725L14.4514 8.60535L17.6365 9.2112C18.4507 9.36605 18.7798 10.319 18.2249 10.9151L15.9664 13.3415L16.3812 16.5888C16.4857 17.4065 15.6057 18.0073 14.8427 17.6394L12 16.2687L9.15724 17.6394C8.39424 18.0073 7.51429 17.4065 7.61874 16.5888L8.03359 13.3415L5.77504 10.9151C5.22019 10.319 5.54929 9.36605 6.36349 9.2112L9.54859 8.60535L11.0509 5.80725Z" />
                        </svg>
                        <div data-i18n="Analytics">Reward Points</div>
                    </Link>
                </li>

                {(isSuperAdmin === 1 || isRegionAdmin === 1) &&
                    <li className="menu-item dropdown_menu" onClick={toggleSubMenu}>
                        <div className="dropdown_title">
                            <div className="dropdown_it">
                                <i className="bx bxs-dashboard"></i>
                                <h2>Masters</h2>
                            </div>

                            <i className={showSubMenu ? "bx bx-chevron-up" : "bx bx-chevron-down"}></i>
                        </div>
                        {showSubMenu && (
                            <ul className="sub-menu">

                                {isSuperAdmin === 1 &&
                                    <li>
                                        <Link className="submenu-link active_submenu" to="regions">
                                            <div data-i18n="Analytics">Regions</div>
                                        </Link>
                                    </li>
                                }
                                {(isSuperAdmin === 1 || isRegionAdmin === 1) &&
                                    <li>
                                        <Link className="submenu-link" to="chapters">
                                            <div data-i18n="Analytics">Chapters</div>
                                        </Link>
                                    </li>
                                }
                                {isSuperAdmin === 1 &&
                                    <li>
                                        <Link className="submenu-link" to="user-roles">
                                            <div data-i18n="Analytics">User Roles</div>
                                        </Link>
                                    </li>
                                }
                                {isSuperAdmin === 1 &&
                                    <li>
                                        <Link className="submenu-link" to="category">
                                            <div data-i18n="Analytics">Business Category</div>
                                        </Link>
                                    </li>
                                }
                                {isSuperAdmin === 1 &&
                                    <li>
                                        <Link className="submenu-link" to="region-admin-users">
                                            <div data-i18n="Analytics">Region Admins</div>
                                        </Link>
                                    </li>
                                }
                                {(isSuperAdmin === 1 || isRegionAdmin === 1) &&
                                    <li>
                                        <Link className="submenu-link" to="chapter-admin-users">
                                            <div data-i18n="Analytics">Chapter Admins</div>
                                        </Link>
                                    </li>
                                }
                            </ul>
                        )}
                    </li>
                }

            </ul>
            {/* New */}
            <div id="accordian" className="menu-parent style1">
                        <ul className="menu">
                            <li className="menu-child">
                                <Link to="/Dashboard">Reports</Link>
                            </li>
                            <MenuItem
                                title="Dashboard"
                                iconClass="fa fa-tachometer"
                            >
                                <li><Link to="#">Reports</Link></li>
                                <li><Link to="#">Recent activities</Link></li>
                                <li><Link to="#">Picto graphs</Link></li>
                                <li><Link to="#">Updates</Link></li>
                            </MenuItem>
                            <MenuItem
                                title="Charts"
                                iconClass="fa fa-bar-chart"
                            >
                                <li><Link to="#">Recent uploads</Link></li>
                                <li>
                                    <Link to="#">Highcharts</Link>
                                    <ul>
                                        <li><Link to="#">Public Feedback</Link></li>
                                        <li><Link to="#">Urgent Tasks</Link></li>
                                        <li>
                                            <Link to="#">Pending</Link>
                                            <ul>
                                                <li><Link to="#">Recent pendings</Link></li>
                                                <li><Link to="#">Urgent pendings</Link></li>
                                                <li><Link to="#">Overdues pendings</Link></li>
                                                <li><Link to="#">Recurring pendings</Link></li>
                                                <li><Link to="#">Settings</Link></li>
                                            </ul>
                                        </li>
                                        <li><Link to="#">Global feedback</Link></li>
                                        <li><Link to="#">Feedback settings</Link></li>
                                    </ul>
                                </li>
                                <li><Link to="#">Recurring</Link></li>
                                <li><Link to="#">Settings</Link></li>
                            </MenuItem>
                            {/* Add more MenuItems for other menu items */}
                        </ul>
                    </div>
            {/* New */}
        </aside>
    );
};

export default Sidebar;


